import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

    @HostBinding('class') @Input() type: 'primary' | 'secondary' | 'simple' | 'warning' | 'danger' | 'success' = 'primary';
    @HostBinding('class.with-icon') @Input() icon = '';
    @HostBinding('class.selected') @Input() selected = false;
    @HostBinding('class.disabled') @Input() disabled = false;
    @Input() library: 'material' | 'fontawesome' | 'prime' = 'fontawesome';

    @Output() clicked = new EventEmitter<any>();

    isHover = false;


    @HostListener('mouseover') mouseover() {
        this.isHover = true;
    }

    @HostListener('mouseleave') mouseleave() {
        this.isHover = false;
    }

    @HostListener('click', ['$event'])
    public onClick(event: PointerEvent): void {
        this.clicked.emit(event);
    }

}
